import React from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from './MarkdownContent';
import { FileDownloader } from '../../FileDownloader';
import {
  Card, CardTitle, InfoGrid, InfoItem, InfoLabel, InfoValue, DownloadLink,
} from './CompanyPage.styles';

const BackgroundView = observer(({ background }) => {
  if (!background) return null;

  const {
    ceo, yearFounded, numberOfEmployees, isPublic, numberOfOffices,
    history, mission, uploadLink, uploadKey,
  } = background;

  return (
    <>
      <InfoGrid>
        {ceo && (
          <InfoItem>
            <InfoLabel>CEO</InfoLabel>
            <InfoValue>{ceo}</InfoValue>
          </InfoItem>
        )}
        {yearFounded > 0 && (
          <InfoItem>
            <InfoLabel>Year Founded</InfoLabel>
            <InfoValue>{yearFounded}</InfoValue>
          </InfoItem>
        )}
        {numberOfEmployees > 0 && (
          <InfoItem>
            <InfoLabel>Employees</InfoLabel>
            <InfoValue>{numberOfEmployees?.toLocaleString()}</InfoValue>
          </InfoItem>
        )}
        <InfoItem>
          <InfoLabel>Company Type</InfoLabel>
          <InfoValue>{isPublic ? 'Public' : 'Private'}</InfoValue>
        </InfoItem>
        {numberOfOffices > 0 && (
          <InfoItem>
            <InfoLabel>Office Locations</InfoLabel>
            <InfoValue>{numberOfOffices}</InfoValue>
          </InfoItem>
        )}
      </InfoGrid>

      {history && (
        <Card>
          <CardTitle style={{ marginBottom: 16 }}>Company History</CardTitle>
          <MarkdownContent markdown={history} />
        </Card>
      )}

      {mission && (
        <Card>
          <CardTitle style={{ marginBottom: 16 }}>Company Mission</CardTitle>
          <MarkdownContent markdown={mission} />
        </Card>
      )}

      {(uploadLink || uploadKey) && (
        <Card>
          <CardTitle style={{ marginBottom: 16 }}>Document</CardTitle>
          {uploadLink ? (
            <DownloadLink href={uploadLink} target="_blank" rel="noopener noreferrer">
              {'\u{1F4CE}'} Download Attached Document
            </DownloadLink>
          ) : (
            <DownloadLink as="span" style={{ cursor: 'pointer' }} onClick={() => FileDownloader(uploadKey)}>
              {'\u{1F4CE}'} {uploadKey.split('/').pop()}
            </DownloadLink>
          )}
        </Card>
      )}
    </>
  );
});

export default BackgroundView;
